// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contacts-module__columnText--Lzhny {
    display: flex;
    flex-direction: column;
}

.Contacts-module__title--oIh0E {
    color: #6F879C;
    font-size: 20px;
    font-weight: 400;
    border-bottom: 1px solid #6f879c4b;
}

.Contacts-module__infoText--vzZ5s>.Contacts-module__icon--Q09b7 {
    color: #0054E6;
}

.Contacts-module__infoText--vzZ5s {
    margin: 0 10px 20px;
    color: #516372;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.Contacts-module__link--yiusn {
    text-decoration: none;
}

.Contacts-module__contentBox--OdrFv {
    display: flex;
    gap: 40px;
    justify-content: center;
    align-items: center;
    height: 40vh;
}

@media (max-width: 800px) {
    .Contacts-module__contentBox--OdrFv {
        display: flex;
        flex-direction: column;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/contacts/Contacts.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;;AAEJ","sourcesContent":[".columnText {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.infoText>.icon {\r\n    color: #0054E6;\r\n}\r\n\r\n.infoText {\r\n    margin: 0 10px 20px;\r\n    color: #516372;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n.link {\r\n    text-decoration: none;\r\n}\r\n\r\n.contentBox {\r\n    display: flex;\r\n    gap: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 40vh;\r\n}\r\n\r\n@media (max-width: 800px) {\r\n    .contentBox {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"columnText": `Contacts-module__columnText--Lzhny`,
	"title": `Contacts-module__title--oIh0E`,
	"infoText": `Contacts-module__infoText--vzZ5s`,
	"icon": `Contacts-module__icon--Q09b7`,
	"link": `Contacts-module__link--yiusn`,
	"contentBox": `Contacts-module__contentBox--OdrFv`
};
export default ___CSS_LOADER_EXPORT___;
